import React, { useState } from 'react';

// components
import EmptyData from '../../../components/EmptyData/EmptyData';

// icons
import icon from '../../../brand/generated/buttonIcons/addDeal.svg';

const NewCarDeal = () => {
  return (
    <>
      <EmptyData
        title={'Ð¡Ð´ÐµÐ»ÐºÐ°'}
        subtitle={'Ð­ÑÐ¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ ÑÑÐ°ÑÑÐ²ÑÐµÑ Ð½Ð¸ Ð² Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ'}
        action="Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¼"
        icon={icon}
      />
    </>
  );
};

export default NewCarDeal;
